<template>
    <div class="mb-2">
        <a :href="resultItem.url" class="link">
            <h3>{{ resultItem.title }}</h3>
            <p class="mb-0">{{ resultItem.text }}</p>
            Lees meer</a
        >
    </div>
</template>

<script>
export default {
    props: {
        resultItem: {
            type: Object,
            default() {
                return {};
            }
        }
    }
};
</script>

<style lang="scss"></style>
